var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        filterable: "",
        remote: "",
        clearable: "",
        "remote-method": _vm.cardsAndVinSerch,
        placeholder: "请选择车牌号",
        size: "small",
      },
      model: {
        value: _vm.carNumberSelect,
        callback: function ($$v) {
          _vm.carNumberSelect = typeof $$v === "string" ? $$v.trim() : $$v
        },
        expression: "carNumberSelect",
      },
    },
    _vm._l(_vm.cardList, function (item) {
      return _c("el-option", {
        key: item[_vm.value],
        attrs: { label: item[_vm.label], value: item[_vm.value] },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }